import DashboardLayout from "../pages/Dashboard/Layout/DashboardLayout";

const readyToBill = () => import("../pages/TaxReceipt/ToBill/ReadyToBill.vue");
const TaxReceiptLoad = () => import("../pages/TaxReceipt/TaxReceiptLoad");
const TaxReceipt = () => import("../pages/TaxReceipt/TaxReceipt");
const Complements = () => import("../pages/TaxReceipt/ComplementsLoad");
const TaxReceiptDetail = () =>
  import("../pages/TaxReceipt/TaxReceipt/detailInvoice.vue");
const InvoiceReceipt = () => import("../pages/TaxReceipt/InvoiceReceipt");
// const Cancellation = () => import("../pages/TaxReceipt/Cancellation");

import store from "@/store";

const invoicePages = {
  path: "/",
  component: DashboardLayout,
  name: "invoicePages",
  title: "Facturación",
  excludedGroups: ["Extranet"],
  excludedRoles: ["IDEAL"],
  icon: "receipt",
  children: [
    {
      path: "/readytobill",
      name: "Listos para Facturar",
      title: "Listos para Facturar",
      meta: {
        ifUserCan: {
          view: "Sinister/sinister",
        },
      },
      component: readyToBill,
    },
    {
      path: "/invoice",
      name: "Facturación",
      title: "Facturación",
      meta: {
        ifUserCan: {
          add: "TaxReceipt/taxreceipt",
        },
      },
      // excludedRoles: ['REVI'],
      component: TaxReceiptLoad,
    },
    {
      path: "/billed",
      name: "Facturados",
      title: "Facturados",
      component: TaxReceipt,
      meta: {
        ifUserCan: {
          view: "TaxReceipt/taxreceipt",
        },
      },
    },
    // {
    //   path: "/cancelacion",
    //   name: "Cancellation",
    //   title: "Cancelación",
    //   component: Cancellation,
    //   ifInGroup: ['Admin'],
    //   meta: {
    //     ifUserCan: {
    //       view: "TaxReceipt/taxreceipt",
    //     },
    //   },
    // },
    {
      path: "/invoicereceipt",
      name: "Contrarecibos",
      title: "Contrarecibos",
      component: InvoiceReceipt,
      meta: {
        ifUserCan: {
          view: "TaxReceipt/invoicereceipt",
        },
      },
      props: () => {
        const userRole = store.getters["account/userRole"];
        return {
          defaultStampedFilter: userRole === "REVI" ? 0 : 1,
        };
      },
    },
    {
      path: "/complements",
      props: true,
      title: "Complementos",
      name: "Complements",
      // excludedRoles: ['REVI'],
      component: Complements,
      meta: {
        ifUserCan: {
          add: "TaxReceipt/taxreceiptcomplement",
        },
      },
    },
    {
      path: "/billed/:id",
      props: true,
      name: "Detalle de Factura",
      // excludedRoles: ['REVI'],
      component: TaxReceiptDetail,
      meta: {
        ifUserCan: {
          view: "TaxReceipt/taxreceipt",
        },
      },
    },
  ],
};

export default invoicePages;



// WEBPACK FOOTER //
// ./src/router/invoiceRoutes.js